export const ShowBirthDay = (bDate) => {

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const d = new Date(bDate);
let month = months[d.getMonth()];
let day = d.getDate();

    
    // current timestamp in seconds (UTC)
    const bDayString = month + " " + day
  
    // Compare the current timestamp with the token's expiration timestamp
    return bDayString;
  };